import $ from 'jquery';

const $archives = $( '.js-blog-archive' );
$archives.each( function () {
	const $archive = $( this );
	const $loadMoreBtn = $archive.find( '.js-blog-archive__load-more-btn' );
	const $row = $archive.find( '.js-blog-archive__row' );
	let xhr;

	$archive.on( 'click', '.js-blog-archive__load-more-btn', function ( e ) {
		e.preventDefault();

		if ( xhr ) {
			// ajax request already in progress
			return;
		}

		const currentPage = $archive.data( 'current-page' ) || 1;
		// $loadMoreBtn.addClass( 'c-link-load--disabled' );

		xhr = $.ajax( {
			url: window.designstudio.ajaxUrl,
			data: {
				action: 'designstudio_load_more_blog_posts',
				designstudio_page: currentPage + 1,
				designstudio_posts_per_page: window.designstudio.blogPostsPerPage,
			},
			dataType: 'json',
			success: function( data ) {
				$archive.data( 'current-page', data.page );
				$( data.data ).hide().appendTo( $row ).fadeIn();

				if ( ( data.page + 1 ) < Math.ceil( data.found_posts / window.designstudio.blogPostsPerPage ) ) {
					// has more results
				} else {
					// no more results
					$loadMoreBtn.css( 'display', 'none' );
				}
			},
			error: function() {
				// console.log( 'error' );
			},
			complete: function () {
				// $loadMoreBtn.removeClass( 'c-link-load--disabled' );
				xhr = undefined;
			}
		} );
	} );
} );
